import { useCallback, useReducer } from 'react'

const ADDRESS = '0x8f693ca8d21b157107184d29d398a8d082b38b76'

const SYMBOL = 'DATA'

const DECIMALS = 18

const IMAGE = 'https://streamr-public.s3.amazonaws.com/streamr-new-token-mark.svg'

export default function useWatchToken(adapter) {
    const [added, setAdded] = useReducer(() => true, false)

    const watch = useCallback(async () => {
        if (!adapter || !adapter.canWatchAsset()) {
            return
        }

        try {
            const succeeded = await adapter.getProvider().request({
                method: 'wallet_watchAsset',
                params: {
                    type: 'ERC20',
                    options: {
                        address: ADDRESS,
                        symbol: SYMBOL,
                        decimals: DECIMALS,
                        image: IMAGE,
                    },
                },
            })

            if (succeeded) {
                setAdded()
            }
        } catch (error) {
            console.error(error)
        }
    }, [adapter])

    const canWatch = !!adapter && adapter.canWatchAsset() && !added

    return [canWatch, watch]
}
